import { render, staticRenderFns } from "./BolhaDoChatDeSuporte.vue?vue&type=template&id=7c13b7e9&scoped=true&"
import script from "./BolhaDoChatDeSuporte.vue?vue&type=script&lang=ts&"
export * from "./BolhaDoChatDeSuporte.vue?vue&type=script&lang=ts&"
import style0 from "./BolhaDoChatDeSuporte.vue?vue&type=style&index=0&id=7c13b7e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c13b7e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
